export const enableAnimation = (element: HTMLDivElement, enabled: boolean) => {
  element.style.transition = enabled ? 'transform 0.3s ease-in-out' : 'none'
}

export const enablePointerEvents = (
  element: HTMLDivElement,
  enabled: boolean
) => {
  element.style.pointerEvents = enabled ? 'auto' : 'none'
}
